import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#if this.canDeleteElement}}\n  <button\n    type=\'button\'\n    class=\'button alert prevent-click-animation\'\n    data-test-toggle-remove ...attributes {{on \'click\' (fn @toggleRemove true)}}\n  ><FaIcon @icon=\'trash-can\' aria-hidden=\'true\' />\n    {{t \'delete\'}}\n  </button>\n{{/if}}\n\n{{#if this.canArchiveElement}}\n  {{#let (if @item.archivied (t \'restore\') (t \'trashing\')) as |archiveText|}}\n    <button\n      type=\'button\'\n      class=\'button prevent-click-animation\'\n      data-test-toggle-remove-2\n      {{on \'click\' (fn @toggleRemove false)}}\n    >\n      {{archiveText}}\n    </button>\n  {{/let}}\n{{/if}}");

var _class, _descriptor;
let BbDeleteButtonComponent = (_class = class BbDeleteButtonComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
  }
  get canArchiveElement() {
    const val = this.args.canArchiveElement ?? true;
    return val !== 'false' && val !== false;
  }
  get canDeleteElement() {
    if (!this.args.item) return false;
    let modelName = this.args.item.constructor.modelName;
    if (modelName === 'invoice' && this.args.item.estimate) {
      modelName = 'estimate';
    }
    return this.session.me?.get?.(`role.${modelName}_delete`) ?? false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
setComponentTemplate(TEMPLATE, BbDeleteButtonComponent);

export { BbDeleteButtonComponent as default };
//# sourceMappingURL=bb-delete-button.js.map
